import { createAction, props } from '@ngrx/store';
import { DetallesCartera } from 'src/app/models/detallesCartera.model';


export const listDetallesCarteras = createAction('[DETALLESCARTERAS] List DetallesCarteras');

export const addDetallesCarteras = createAction('[DETALLESCARTERAS] Add List DetallesCarteras', props<{ list: DetallesCartera[] }>());

export const addDetallesCartera = createAction('[DETALLESCARTERAS] Add DetallesCartera', props<{ Detallescartera: DetallesCartera }>());

export const selectDetallesCartera = createAction('[DETALLESCARTERAS] Select DetallesCartera',props<{id:number}>())

export const updateListDetallesCarteras = createAction('[DETALLESCARTERAS] Update List DetallesCarteras', props<{ id: number, DetallesCartera: DetallesCartera }>());

export const deleteDetallesCartera = createAction('[DETALLESCARTERAS] Delete DetallesCartera', props<{id: number}>());